import { PagingParams } from '../types/PagingParams';
import { axiosInstance } from './axios';
import { pagingToParams } from '../utils';
import { REACT_APP_API_SERVER_URL } from './constants';

export const getBills = async (params: PagingParams) => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/bill`,
    { params: pagingToParams(params) },
  );

  const {
    data: { content, totalPages, totalElements },
  } = response;

  return {
    bills: content,
    totalPageCount: totalPages,
    totalBills: totalElements,
    page: params.page,
  };
};

export const filterBills = async (params: PagingParams) => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/bill/filtered`,
    params.filter,
    { params: pagingToParams(params) },
  );

  const {
    data: { content, totalPages, totalElements },
  } = response;

  return {
    bills: content,
    totalPageCount: totalPages,
    totalBills: totalElements,
    page: params.page,
  };
};

export const fetchStatusList = async () => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/bill/status/list`,
  );

  return response.data;
};

export const fetchNumberList = async () => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/bill/number/list`,
  );

  return response.data;
};

export const getBillPdf = async (billNumber: string) => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/bill/pdf`,
    {
      params: {
        billNumber,
      },
      responseType: 'blob',
    },
  );

  return response.data;
};

export const getBillsZip = async (billNumbers: string[]) => {
  const billParams = billNumbers
    .map((billNumber) => billNumber.trim())
    .join(',');
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/bill/zip`,
    {
      params: {
        billNumbers: billParams,
      },
      responseType: 'blob',
    },
  );

  return response;
};
